export class InteractiveDataAnalysisProperty {
  color: string;
  minY: number;
  maxY: number;
  customRange: boolean;

  constructor(color, minY?, maxY?) {
    this.color = color || '#ccc';
    this.minY = minY || 0;
    this.maxY = maxY || 0;
    this.customRange = (this.maxY !== 0 || this.minY !== 0);
  }
}
